import React, { useEffect, useState } from "react";
import { Button, Grid, Box, Typography, CircularProgress, Chip, Stack } from "@mui/material";
import GenericModal from '../../../components/common/modal';
import GenericTable from "../../../../src/components/table/index"
import GroupForm from "./form"
import { GroupApi } from "../../../apis";
import { useNavigate } from "react-router-dom";
function Groups() {
    const navigate = useNavigate();
    const columns = [
        { field: "id", headerName: "ID" },
        { field: "name", headerName: "Name", sortable: true },
        { field: "description", headerName: "Description", sortable: true },
        { field: "status", headerName: "Status", sortable: true },
        {
            field: "groupUser",
            headerName: "Group Users",
            renderCell: (params) => {
                const users = params.row.groupUser?.map(g => g.user?.name).filter(Boolean) || [];
                return users.length > 0 ? (
                    <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
                        {users.map((user, index) => (
                            <Chip key={index} label={user} size="small" />
                        ))}
                    </Stack>
                ) : (
                    <Typography variant="body2" color="textSecondary">No Users</Typography>
                );
            }
        }
    ]
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const fetchGroups = async () => {
        try {
            const res = await GroupApi.getAllGroups();
            setGroups([...res.data.data]);
        } catch (error) {
            console.error('Error fetching groups:', error);
            setGroups([]);
        } finally {
            setLoading(false);
        }
    };
    const handleEdit = async (group) => {
        try {
            await GroupApi.updateGroup(group.id, group);
            fetchGroups(); // Refresh the groups list
        } catch (error) {
            console.error('Error updating group:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            await GroupApi.deleteGroup(id); // Replace with your API call
            fetchGroups(); // Refresh the projects list after deleting
        } catch (error) {
            console.error('Error deleting project:', error);
        }
    };
    useEffect(() => {
        fetchGroups();
    }, []);
    return (
        <>
            <Box>
                <Grid container spacing={2} mt={2} mb={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Typography variant="h4" fontWeight={600}>
                            Groups
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={6}
                        display="flex"
                        justifyContent="flex-end"
                    >
                        <Button variant="contained" color="primary" onClick={handleOpen}>
                            Add Group
                        </Button>
                    </Grid>
                </Grid>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                        <CircularProgress />
                    </Box>
                ) : (

                    <GenericTable
                        type="groups"
                        data={groups}
                        columns={columns}
                        onView={(id) => {
                            navigate(`/admin/view-time-sheet/${id}`);
                        }}
                        onEdit={(group) => handleEdit(group)}
                        onDelete={handleDelete}
                        fetchAllGroups={fetchGroups}
                        assign={true}
                        addUser={true}
                        onAddUser={(group) => handleEdit(group)}

                    />
                )}
                <GenericModal
                    open={open}
                    handleClose={handleClose}
                    title="Add Group"
                    handleSave={() => {
                        fetchGroups(); // Refresh the users list after adding a new user
                        handleClose(); // Close the modal
                    }}
                >
                    <GroupForm handleClose={handleClose} fetchGroups={fetchGroups} close={handleClose} />
                </GenericModal>
            </Box>
        </>
    );
}

export default Groups;
